import React, {useEffect, useCallback, useReducer} 
                                        from 'react';                                    
import {PlusInput, Show, Hide}                        
                                        from '../../lib/iprs-react-library/src/index.js';
import TemplateLink                     from './TemplateLink';

/* 
 * React component to display a list of templates
 */
const TemplateSelector = ({api, eventDispatch, state }) => {
    
    
    const { template: { templates, templateID, hidden }, pageState }         = state
    
    useEffect( () => {
        /* we load from the store the first and dispatch the result to the rest 
         * of the application  */
        eventDispatch( { template: { hidden: loadHidden() } } ) 
    } ,[eventDispatch] );
    

    
    // flag for wheather or not to show hidden
    const [showHidden, toggleShowHidden]   = 
            useReducer( (oldSH, newSH) => storeShowHidden( !oldSH ), 
                        undefined, loadShowHidden );
    
    /* selectedTemplateID parameter allows callers to specify which template should
     * be selected when the list loads. This is needed when creating a new template
     * to avoid a race condition where the state hasn't updated yet but we want to
     * ensure the newly created template is selected. */
    const loadList = useCallback((selectedTemplateID = null) => {
        const idToSelect = selectedTemplateID !== null ? selectedTemplateID : templateID;

        api.getRotaTemplateList()
            .then( response => response.apiResult )
            .then( templates => templates.filter( t => !t.Deleted ) )
            .then( templates => templates.map( t => {
                return { Deleted: t.Deleted,
                    id: Number.parseInt( t.pkRotaWeekTemplateID, 10 ), Name: t.TemplateName }
            } ) )
            .then(
                loadedTemplates => {

                    let event = {
                        template: { templates: loadedTemplates }
                    };
                    if ( loadedTemplates.map( t => t.id ).includes( idToSelect ) ){
                        event.template.templateID = idToSelect;
                    }

                    eventDispatch( event )
                }
            )
            .catch( err => console.log('Error loading template', err) );}, [api, eventDispatch, templateID])
    
    useEffect( loadList, [api, eventDispatch, templateID, loadList]);
    
    const handleSelectTemplate = useCallback( e => {
        e.preventDefault()
        
        eventDispatch( { template: 
                    {templateID: Number.parseInt( e.target.name, 10 ) } } )
    }, [eventDispatch] );
    
    const createTemplate = useCallback( e => {

        api.createTemplate( e.target.value )
            .then( r => r.apiResult )
            .then( r => {
                const newTemplateID = Number.parseInt(r.RotaWeekTemplateID, 10);
                eventDispatch( {
                    template: { templateID: newTemplateID },
                    menu: 'template'
                } );
                /* Pass the new template ID to loadList to ensure it remains selected
                 * after the list refreshes */
                loadList(newTemplateID);
            } )
            .catch( err => console.log( err.message ) );
    }, [api, eventDispatch, loadList] );
    
    const deleteTemplate = useCallback( id => {
            api.deleteTemplate( id )
                .then( r => r.apiResult )
                .then( r => loadList() )
                .catch( err => console.log( err.message ) );
        }, [api, loadList] );
    

    
    const templateLink = useCallback( (id, name, isHidden) => {
        const setHidden = newHidden => {      
            /* store the list of hidden templates and send the update to the 
            * application */
            storeHidden(newHidden);
            eventDispatch( { template: { hidden: loadHidden() } } ) 
        }

        const saveTemplateName = (id, name) => {
            api.updateTemplate( id, name )
                .then( r => loadList() )
                .catch( err => console.log( err.message ) );
        }
        
        const active = 'template' === pageState && id === templateID;
        
        /* toggles the hidden status of a templateID by adding or removing from the 
         * hidden list */
        const toggleHidden = templateID => {
            const hiddenList = loadHidden();
            const isHidden = hiddenList.includes( templateID );
            if( isHidden ){
                setHidden( hiddenList.filter( t => templateID !== t ) );
            }else{
                setHidden( [...hiddenList, templateID] );
            }
        }
        
        return <TemplateLink key={id} id={id} name={name} isHidden={isHidden} active={active}
            deleteTemplate={deleteTemplate} handleSelectTemplate={handleSelectTemplate} 
            toggleHidden={toggleHidden} saveTemplateName={saveTemplateName} />
    }, [templateID, pageState, deleteTemplate, handleSelectTemplate, api, loadList, eventDispatch]);
    
    return (
        <>
        <div>{showHidden?
        <Show onClick={toggleShowHidden} title='Hide templates' />: 
        <Hide onClick={toggleShowHidden} title='Show all templates' />}</div>

        <ul className='' >
            {templates
                .map( t => { return{...t, hidden: hidden.includes( t.id )};} )
                .filter( t => showHidden || !t.hidden )
                .map( t => templateLink( t.id, t.Name, t.hidden ) )}
            </ul>
            <div style={{ marginBottom: '1em' }}>
                <PlusInput onClick={createTemplate} />
         </div>
        </>
    )
};


const storage = window.localStorage;

const hiddenKey     = 'hiddenTemplates';
const showHiddenKey = 'showHiddenKey';

const load = (key,init) => {
    
    let result = null;
    try{
        result = JSON.parse( storage.getItem(key) );
        // only deal with Array and boolean but this is limiting
        if( Array.isArray( result ) !== Array.isArray( init ) ){
            // Error object is needed to throw error.
            throw Object.assign(new Error("result is not same as init"),
                {code: 402}
            );
        }
    }catch( e ){
        store( key, init );
        result = init
    }
    
    return result;
}

const store = (key, value) => {
    storage.setItem( key, JSON.stringify( value ) );
    return value;
}

/* function to store hidden TemplateIDs */
const storeHidden = hiddenTemplateIDs => store( hiddenKey, hiddenTemplateIDs );

/* function to get list of hidden TemplateIDs */
const loadHidden = () => load(hiddenKey, []);



/* function to store value of showHidden flag */
const storeShowHidden = hiddenTemplateIDs => store( showHiddenKey, hiddenTemplateIDs );

/* function to get value of showHidden flag */
const loadShowHidden = () => load(showHiddenKey, false);

export default TemplateSelector;


